import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "notice",
  "use": "notice-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"notice\">\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.087,15.218H3.913C3.409,15.218,3,14.803,3,14.291s0.409-0.927,0.913-0.927\r\n\ts0.913-0.416,0.913-0.927V6.254c0-2.39,1.908-4.327,4.261-4.327C9.087,1.415,9.496,1,10,1s0.913,0.415,0.913,0.927\r\n\tc2.353,0,4.261,1.938,4.261,4.327v6.182c0,0.512,0.409,0.927,0.913,0.927S17,13.779,17,14.291S16.591,15.218,16.087,15.218z M10,18\r\n\tc-1.009,0-1.826-0.83-1.826-1.854h3.652C11.826,17.17,11.008,18,10,18z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id